<template>
  <div class="outerbox havebacker">
    <div class="innercoreversion haveconten">
      <div class="imgbox"><img width="754px" src="../image/titlabout.png" alt="" /></div>
      <div class="textbox">
        宇亿润宸网络科技（深圳）有限公司是一家以物联网为基础的科技公司，具备完善的研发、生产、销售、测试、运维体系。拥有多项专利与核心技术，包含一项发明专利，发布了自主知识产权的独创产品。在满足客户需求的基础上，秉持工匠精神，与肯德基、星巴克、奈雪、亚朵等多家知名企业建立了长期合作开发关系，不断改良产品、创新技术，得到客户广泛好评。
      </div>
      <div class="bouttonquike" @click="scrollToAnchor">快速体验</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'haveBacker',
  methods: {
    scrollToAnchor() {
      const targetElement = document.getElementById('about')
      targetElement.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
        block: 'start', // 滚动到目标元素顶部
      })
    },
  },
}
</script>

<style lang="less" scoped>
.havebacker {
  height: 568px;
  background-image: url(../image/bagerimage.png);
  background-size: cover; /* 使图片覆盖整个盒子 */
  background-position: center; /* 将图片居中 */
  background-repeat: no-repeat; /* 防止图片重复 */
  .haveconten {
    height: 100%;
    padding-left: 77px;
    padding-right: 80px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .imgbox {
      text-align: center;
      max-height: 80px;
    }
    .textbox {
      text-indent: 2em;
      margin: 31px 0 106px 0;
    }
    .bouttonquike {
      text-align: center;
      line-height: 56px;
      width: 212px;
      height: 56px;
      background: #57cc9a;
      border-radius: 37px 37px 37px 37px;
    }
  }
}
</style>